module.exports = __webpack_public_path__ + "static/media/3_transformed.f32f3cb7.png";